import React from "react";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Tooltip } from "antd";
import Image from "@components/item/Image";
import AppleLogin from "react-apple-login";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { POST_APPLE_SIGNIN_URL } from "@libs/apiUrl";
import { useNavigate } from "react-router-dom";

const AppleButton = styled.button({
  display: "flex",
});

const tooltipStyle = {
  backgroundColor: "#FF4808",
  borderRadius: "2px ",
  padding: "0.2rem 0.8rem",
  height: "auto",
  minHeight: "auto",
  fontSize: "1.2rem",
  fontFamily: "Pretendard",
};

const AppleLoginButton = ({ recentLogin }: { recentLogin: string | null }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: async (id_token: string) => {
      const { data, headers } = await axios.post(POST_APPLE_SIGNIN_URL, {
        id_token,
      });

      return { data, headers };
    },
    onSuccess: (res) => {
      const { data, headers } = res;

      // console.log("Apple 로그인 성공:", data);

      // 헤더에 토큰이 있는 경우 (가입 유저)
      const isRegistered = !!headers.authorization;

      if (isRegistered && headers.authorization) {
        localStorage.setItem("accessToken", headers.authorization);
        localStorage.setItem("loginType", "APPLE");

        navigate("/");
      }

      // 미가입 유저인 경우 회원가입 페이지로 이동
      if (!isRegistered) {
        navigate("/join", {
          state: {
            login_type: data.data.oauth_provider,
            userData: data.data,
          },
        });
      }
    },
    onError: (error) => {
      console.error("Apple 로그인 실패:", error);
    },
  });

  const responseApple = async (res: any) => {
    if (res?.user?.name) {
      localStorage.setItem("apple_first_name", res.user.name.firstName);
      localStorage.setItem("apple_last_name", res.user.name.lastName);
    }

    if (res?.user?.email) {
      localStorage.setItem("apple_email", res.user.email);
    }

    if (res?.authorization?.id_token) {
      mutate(res.authorization.id_token);
    }
  };

  return (
    <Tooltip
      title={recentLogin === "APPLE" ? "최근 로그인" : ""}
      placement="top"
      open={recentLogin === "APPLE"}
      color="#FF4808"
      overlayInnerStyle={tooltipStyle}>
      <AppleLogin
        clientId={process.env.REACT_APP_APPLE_REST_API_KEY || ""}
        redirectURI={process.env.REACT_APP_APPLE_REDIRECT_URI || ""}
        usePopup={true} // 로그인 팝업창
        responseType="code id_token" // 코드 + 사용자정보
        responseMode="form_post"
        scope="email name" // 요청할 정보
        state={Math.random().toString(36).substring(7)}
        callback={responseApple} // 로그인 후 애플 응답처리
        render={({ onClick }) => (
          <AppleButton type="button" onClick={onClick}>
            <Image
              src={theme.image.apple_icon}
              width="5.2rem"
              height="5.2rem"
            />
          </AppleButton>
        )}
      />
    </Tooltip>
  );
};

export default AppleLoginButton;
